import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import styles from './PlateScore.module.scss'
import { PlateRegister } from './PlateRegister'

/**
 * CARD 02 — the shortlist forming.
 *
 * A named person, the phrase they published marked in their line, and the number it earned. The rows
 * arrive on a stagger; whoever lands under the dashed qualify bar stays grey and never reaches the
 * buyer — the refusal is part of the figure, because it is part of the product.
 *
 * It replaced a bar chart. Bars measured a score, which was the old copy's promise; this shows the
 * thing the step actually hands over.
 */
/* Имена ВЫДУМАНЫ и проверены по индексу: `Nora Kirsch`, `Elias Reed`, `Tomas Vance` и каждая их
   часть дают ноль совпадений в `candidates.name` на проде. Настоящего участника на публичный
   лендинг ставить нельзя — это уже ловили в соседней миниатюре. Должности переводятся, имена нет:
   имя собственное не переводят ни в одной локали. */
const ROWS = [
  { key: 'ops', name: 'Nora Kirsch', y: 34, score: 86, qualified: true },
  { key: 'ceo', name: 'Elias Reed', y: 72, score: 79, qualified: true },
  { key: 'sales', name: 'Tomas Vance', y: 110, score: 38, qualified: false },
] as const

/** Rows are 38 apart; every mark inside one is placed relative to its centre. */
export const PlateScore = () => {
  const { t } = useTranslation()

  return (
  <div className={styles.plate}>
    <svg viewBox="0 0 360 160" aria-hidden focusable="false">
      <defs>
        <clipPath id="plateScoreAvatar">
          <circle cx={34} cy={26} r={13} />
        </clipPath>
      </defs>
      <PlateRegister
        figure="02"
        hairClassName={styles.hair as string}
        hair2ClassName={styles.hair2 as string}
        numberClassName={styles.fno as string}
      />

      {ROWS.map((row, index) => (
        <g
          key={row.key}
          className={cn(styles.row, { [styles.dim as string]: !row.qualified })}
          style={{ animationDelay: `${(index * 0.34).toFixed(2)}s` }}
        >
          <circle className={styles.avatar} cx={34} cy={row.y} r={13} />
          {/* Силуэт, а не инициалы: та же конструкция, что в герое — голова и большой нижний круг,
              верхний край которого и есть линия плеч, оба обрезаны по кружку. */}
          <g className={styles.glyph} clipPath="url(#plateScoreAvatar)" transform={`translate(0 ${row.y - 26})`}>
            <circle cx={34} cy={22} r={4.4} />
            <circle cx={34} cy={36} r={8} />
          </g>

          <text className={styles.name} x={56} y={row.y - 1}>
            {row.name}
          </text>
          <text className={styles.role} x={56} y={row.y + 11}>
            {t(`landing.features.scoreRows.${row.key}`)}
          </text>

          <rect
            className={cn(styles.chip, row.qualified ? styles.pass : styles.fail)}
            x={288}
            y={row.y - 11}
            width={48}
            height={22}
            rx={7}
          />
          <text className={styles.score} x={312} y={row.y + 4} textAnchor="middle">
            {row.score}
          </text>
        </g>
      ))}

      {/* The qualify bar: whoever lands under it never reaches the buyer. */}
      <line className={styles.qualifyBar} x1={14} y1={92} x2={346} y2={92} />
    </svg>
  </div>
)
}
